// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  matchId: __t.string().primaryKey().name("match_id"),
  phase: __t.string(),
  buildRemainingMicros: __t.u64().name("build_remaining_micros"),
  buildLastStartedAt: __t.option(__t.timestamp()).name("build_last_started_at"),
  startRemainingMicros: __t.u64().name("start_remaining_micros"),
  startLastStartedAt: __t.option(__t.timestamp()).name("start_last_started_at"),
  startLocked: __t.bool().name("start_locked"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
